export default {
  path: '/provider-imports',
  name: 'provider-imports',
  component: () => import(/* webpackChunkName: "imported-providers" */ './ImportedProviders'),
  meta: { requiresAuth: true }
}
